import {
    UPDATE_ACCOUNT_RESET, UPDATE_ACCOUNT,
    UPDATE_DETAILED_PROFILE_FORM_VIEWED_FAILURE, UPDATE_DETAILED_PROFILE_FORM_VIEWED_SUCCESS,
    GET_REDEMPTION_ACCOUNTS, GET_REDEMPTION_ACCOUNTS_RESET, GET_REDEMPTION_ACCOUNT_TOKEN,
    GET_REDEMPTION_ACCOUNT_TOKEN_RESET, GET_ACCOUNT, GET_ACCOUNT_RESET,
    UPDATE_PROFILE_IMAGE, UPDATE_PROFILE_IMAGE_RESET
} from '../actions/user';
const initialState = {
    accountUpdated: null,
    accountUpdatedError: null,
    updateDetailedProfileFormViewedSuccess: null,
    updateDetailedProfileFormViewedFailure: null,
    redemptionAccounts: null,
    redemptionAccountToken: null,
    account: {},
    getAccountError: null,
    getAccountSuccess: null,
    getRedemptionAccountsSuccess: null,
    getRedemptionAccountsError: null,
    getRedemptionAccountTokenSuccess: null,
    getRedemptionAccountTokenError: null,
    updateProfileImageSuccess: null,
    updateProfileImageError: null
};

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case GET_ACCOUNT:
            return {
                ...state,
                ...(action.meta && action.meta.sent && action.payload.account && {
                    getAccountSuccess: true,
                    account: action.payload.account
                }),
                getAccountError: action.error,
            };
        case GET_ACCOUNT_RESET:
            return {
                ...state,
                getAccountError: initialState.getAccountError,
                getAccountSuccess: initialState.getAccountSuccess
            };
        case UPDATE_PROFILE_IMAGE:
            return {
                ...state,
                ...(action.meta && action.meta.sent && {
                    updateProfileImageSuccess: true
                }),
                updateProfileImageError: action.error
            };
        case UPDATE_PROFILE_IMAGE_RESET:
            return {
                ...state,
                updateProfileImageSuccess: initialState.updateProfileImageSuccess,
                updateProfileImageError: initialState.updateProfileImageError,
            };
        case UPDATE_ACCOUNT:
            return {
                ...state,
                accountUpdated: !!action.payload.account,
                accountUpdatedError: action.error,
                ...(action.payload.account && {account: action.payload.account})
            };
        case UPDATE_ACCOUNT_RESET:
            return {
                ...state,
                accountUpdated: initialState.accountUpdated,
            };
        case UPDATE_DETAILED_PROFILE_FORM_VIEWED_SUCCESS:
            return {
                ...state,
                updateDetailedProfileFormViewedSuccess: true,
                updateDetailedProfileFormViewedFailure: null
            };
        case UPDATE_DETAILED_PROFILE_FORM_VIEWED_FAILURE:
            return {
                ...state,
                updateDetailedProfileFormViewedFailure: true,
                updateDetailedProfileFormViewedSuccess: null
            };
        case GET_REDEMPTION_ACCOUNTS:
            return {
                ...state,
                ...(action.payload && action.payload.redemptionAccounts && {redemptionAccounts: action.payload.redemptionAccounts}),
                ...(action.payload && action.payload.redemptionAccounts && {getRedemptionAccountsSuccess: true}),
                getRedemptionAccountsError: action.error
            };
        case GET_REDEMPTION_ACCOUNTS_RESET:
            return {
                ...state,
                getRedemptionAccountsSuccess: initialState.getRedemptionAccountsSuccess,
                getRedemptionAccountsError: initialState.getRedemptionAccountsError
            };
        case GET_REDEMPTION_ACCOUNT_TOKEN:
            return {
                ...state,
                ...(action.payload.redemptionAccountToken && {redemptionAccountToken: action.payload.redemptionAccountToken}),
                ...(action.payload.redemptionAccountToken && {getRedemptionAccountTokenSuccess: true}),
                getRedemptionAccountTokenError: action.error
            };
        case GET_REDEMPTION_ACCOUNT_TOKEN_RESET:
            return {
                ...state,
                getRedemptionAccountTokenSuccess: initialState.getRedemptionAccountTokenSuccess,
                getRedemptionAccountTokenError: initialState.getRedemptionAccountTokenError
            };
        default:
            return state;
    }
}